import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {NavItem} from '../../models/staff/navitem';
import {passBoolean} from 'protractor/built/util';


const apiUrl = `${environment.apiUrl}/api/staff/navitem`;

@Injectable({
  providedIn: 'root'
})
export class NavItemService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<NavItem[]> {
    return this.httpService.get<NavItem[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new NavItem().deserialize(data)))
    );
  }
  findALlByStaffId(staffId: number, type: number, active: boolean): Observable<NavItem[]> {
    return this.httpService.get<NavItem[]>(`${apiUrl}/getallbytypeandactive?stid=${staffId}&type=${type}&active=${active}`).pipe(
      map(data => data.map(data => new NavItem().deserialize(data)))
    );
  }
  checkPermissionByCode(staffId: number, code: string, active: boolean) {
    return this.httpService.get<number>(`${apiUrl}/checkpermissionbycode?stid=${staffId}&cd=${code}&active=${active}`).pipe(
      map(data => Number(data))
    );
  }
  checkPermissionByModule(staffId: number, module: string, action: string) {
    return this.httpService.get<boolean>(`${apiUrl}/checkpermissionbymodule?stid=${staffId}&mid=${module}&ac=${action}`).pipe(
      map(data => data)
    );
  }
  checkNavByCode(staffId: number, code: string) {
    return this.httpService.get<boolean>(`${apiUrl}/checknavbycode?stid=${staffId}&code=${code}`).pipe(
      map(data => data)
    );
  }

}
